import { Box, styled } from '@mui/material';

export const PointSymbol = styled(Box)(({ theme }) => ({
  width: '20px',
  height: '20px',
  backgroundColor: theme.palette.common.white,
  borderRadius: '100%',
  border: `6px solid ${theme.palette.primary.main}`,
  position: 'absolute',
  bottom: '-23px',
  right: '45%',
}));
